import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
const apiAuth0 = axios.create({
  baseURL: process.env.REACT_APP_AUTH0_DOMAIN,
});

export { api, apiAuth0 };
